import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

const VerifyEmail: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { verifyEmail, resendVerification } = useAuth();
  const [otp, setOtp] = useState('');
  const [isResending, setIsResending] = useState(false);
  
  const email = location.state?.email;

  if (!email) {
    navigate('/signup');
    return null;
  }

  const handleVerify = async () => {
    if (otp.length === 6) {
      await verifyEmail(email, otp);
    }
  };

  const handleResend = async () => {
    setIsResending(true);
    await resendVerification(email);
    setIsResending(false);
  };

  return (
    <div className="space-y-6">
      <div className="text-center">
        <h2 className="text-2xl font-bold text-gray-900">Verify your email</h2>
        <p className="mt-2 text-sm text-gray-600">
          We've sent a verification code to{' '}
          <span className="font-medium text-gray-900">{email}</span>
        </p>
      </div>

      <div>
        <label className="label">Verification Code</label>
        <input
          type="text"
          value={otp}
          onChange={(e) => setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))}
          className="input text-center text-2xl tracking-[0.5em]"
          placeholder="000000"
          maxLength={6}
        />
      </div>

      <button
        onClick={handleVerify}
        disabled={otp.length !== 6}
        className="w-full btn-primary disabled:opacity-50"
      >
        Verify Email
      </button>

      <div className="text-center">
        <p className="text-sm text-gray-600">
          Didn't receive the code?{' '}
          <button
            onClick={handleResend}
            disabled={isResending}
            className="font-medium text-brand-600 hover:text-brand-500 disabled:opacity-50"
          >
            {isResending ? 'Sending...' : 'Resend'}
          </button>
        </p>
      </div>
    </div>
  );
};

export default VerifyEmail;
